import FittedImage from './FittedImage';

export default FittedImage;
